import { OrganizationKeyName } from "../../../model/Organization";

export const DELETE_HOMEPAGE_SUCCESS = "SHOP:DELETE_HOMEPAGE_SUCCESS";

export const deleteHomepageSuccessAction = (
  organization: OrganizationKeyName,
  id: string
) => ({
  type: DELETE_HOMEPAGE_SUCCESS as typeof DELETE_HOMEPAGE_SUCCESS,
  organization,
  id,
});

export type DeleteHomepageSuccessAction = ReturnType<
  typeof deleteHomepageSuccessAction
>;
